// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"ReportForm_formContainer__2cSdm","reportTable":"ReportForm_reportTable__nl3Z3","onSubmit":"ReportForm_onSubmit__tyqqG"};